import IosShareIcon from "@mui/icons-material/IosShare";
import { Button } from "@mui/material";

import React from "react";

type Props = {
    label: string;
    shareData: {
        title: string;
        text: string;
        url: string;
    };
};

const WebShare = ({ shareData, label }: Props) => {
    const [canShare, setCanShare] = React.useState(false);

    React.useEffect(() => {
        if (navigator && navigator.canShare && navigator?.canShare(shareData)) {
            setCanShare(true);
        }
    }, [shareData]);

    if (!canShare) {
        return null; // Fallback to other share methods
    }

    const handleClick = async () => {
        try {
            await navigator.share({
                ...shareData,
                url: `${window.location.origin + shareData.url}?utm_source=web-share`
            });
        } catch (err) {
            if (process.env.NODE_ENV === "development") {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        }
    };

    return (
        <Button onClick={handleClick} startIcon={<IosShareIcon />}>
            {label}
        </Button>
    );
};

export default WebShare;
